const isSafari = () => {
    return (navigator.userAgent.indexOf("Safari") !== -1 &&
        navigator.userAgent.indexOf("Chrome") === -1);
};
export default isSafari;
//# sourceMappingURL=isSafari.js.map